<template>
  <div>
    <el-card>
      <div class="history">
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <span class="value">Tran#:</span>
              <span class="label">{{ history.tran }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-light">
              <span class="value">Transaction Type:</span>
              <span class="label">{{ history.approveTypeStr }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <span class="value">Source:</span>
              <span class="label">{{ history.sourceStr }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <span class="value">Credit Line:</span>
              <span class="label">
                {{ $utils.formatAmount(history.amount) }}
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple-light">
              <span class="value">Partial Amount:</span>
              <span class="label">
                {{ $utils.formatAmount(history.reducedAmount) }}
              </span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <span class="value">Effective Date:</span>
              <span class="label">
                {{
                  history.finishTime
                    ? history.finishTime.slice(0, 10)
                    : history.finishTime
                }}
              </span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <span class="value">Expiry Date:</span>
              <span class="label">{{ history.indateEnd }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <span class="value">Modified by:</span>
            <span class="label">{{ history.approver }}</span>
          </el-col>
        </el-row>
      </div>
      <h1>CREDIT ANALYST COMMENTS</h1>
      <customize-form
        style="margin-top: 20px"
        :isShowForm="true"
        :schema="commentsModel"
        ref="analysisComments"
      ></customize-form>
    </el-card>
  </div>
</template>
<script>
import { getDescTran } from '../detail/info/basic-profile/api'
const commentsModel = [
  {
    key: 'creditAnalysisComment',
    label: '',
    type: 'textarea',
    disabled: true,
    value: '',
  },
]
export default {
  data() {
    return {
      history: {},
      commentsModel,
    }
  },
  mounted() {
    this._getHistory()
  },
  methods: {
    async _getHistory() {
      const data = await getDescTran(this.$route.query.id)
      this.history = data
      this.commentsModel = [
        {
          key: 'creditAnalysisComment',
          label: '',
          type: 'textarea',
          value: data.decisionComments,
          disabled: true,
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
:deep(.el-row) {
  margin-top: 20px;
}
h1 {
  margin-top: 30px;
}
.label {
  margin-left: 30px;
}
</style>
